/**
 * Globo Form Builder（.wds-contact-form 内）:
 * - 種別が order / return のときだけ注文番号（.ordernumber）を表示
 * - 種別が product のときだけ商品URL（.product-url）を表示
 * - 種別が return のときだけファイルアップロード（.file-upload）を表示
 * - 種別が store のときだけ店舗連絡先（.store-contact-number）を表示
 * - お問い合わせ種別を選択したら名前（data-type=name）・メール（data-type=email）・本文（data-type=textarea）・注記（.submit-note）・送信フッター（.gfb__footer）を表示
 *
 * URL クエリで select-1 を初期選択（option の value と一致）:
 *   /pages/faq?topic=return
 *   /pages/faq?inquiry=order または ?type=product（別名キー）
 */
(function () {
  const SELECT_NAME = 'select-1';
  const ORDER_SELECTOR = '.globo-form-control.ordernumber';
  const PRODUCT_URL_SELECTOR = '.globo-form-control.product-url';
  const FILE_UPLOAD_SELECTOR = '.globo-form-control.file-upload';
  const LEGAL_NOTICE_SELECTOR = '.globo-form-control.leagal-notice';
  const STORE_CONTACT_SELECTOR = '.globo-form-control.store-contact-number';
  const SHOW_ORDER_VALUES = ['order', 'return'];
  const CONTACT_HASH = '#contact';
  /** select の value と同じ文字列のみ有効（未知の値は無視） */
  const VALID_SELECT_VALUES = [
    'product',
    'shipping',
    'order',
    'return',
    'press',
    'store',
    'other',
  ];
  const TOPIC_QUERY_KEYS = ['topic', 'inquiry', 'type'];

  let scanScheduled = false;
  let urlTopicPresetCache;
  let hashScrollHandled = false;
  let hashScrollAttempts = 0;
  const MAX_HASH_SCROLL_ATTEMPTS = 8;

  function parsePresetFromParams(params) {
    for (let i = 0; i < TOPIC_QUERY_KEYS.length; i++) {
      const raw = params.get(TOPIC_QUERY_KEYS[i]);
      if (raw == null || raw === '') continue;
      const v = String(raw).trim().toLowerCase();
      if (VALID_SELECT_VALUES.indexOf(v) !== -1) {
        return v;
      }
    }
    return null;
  }

  function getUrlTopicPreset() {
    if (urlTopicPresetCache !== undefined) {
      return urlTopicPresetCache;
    }
    urlTopicPresetCache = null;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const fromSearch = parsePresetFromParams(searchParams);
      if (fromSearch !== null) {
        urlTopicPresetCache = fromSearch;
        return urlTopicPresetCache;
      }

      const hash = window.location.hash || '';
      const qIndex = hash.indexOf('?');
      if (qIndex !== -1) {
        const hashParams = new URLSearchParams(hash.slice(qIndex + 1));
        const fromHashQuery = parsePresetFromParams(hashParams);
        if (fromHashQuery !== null) {
          urlTopicPresetCache = fromHashQuery;
        }
      }
    } catch (e) {
      urlTopicPresetCache = null;
    }
    return urlTopicPresetCache;
  }

  function findFormRoots() {
    const roots = [];
    const seen = new Set();

    document.querySelectorAll('.wds-contact-form').forEach(function (el) {
      if (!seen.has(el)) {
        seen.add(el);
        roots.push(el);
      }
    });

    document.querySelectorAll('select[name="' + SELECT_NAME + '"]').forEach(function (select) {
      const root =
        select.closest('.wds-contact-form') ||
        select.closest('[id^="globo-formbuilder-"]') ||
        select.closest('.globo-form-app');
      if (root && !seen.has(root)) {
        seen.add(root);
        roots.push(root);
      }
    });

    return roots;
  }

  function tryApplyUrlTopicPreset(root, select) {
    if (root.dataset.wdsUserChangedSelect === '1') return;

    const preset = getUrlTopicPreset();
    if (preset === null) return;

    const optionsWithValue = Array.from(select.options).filter(function (opt) {
      return opt.value !== '';
    });
    if (optionsWithValue.length === 0) return;

    const matching = optionsWithValue.find(function (opt) {
      return opt.value === preset && !opt.disabled;
    });
    if (!matching) return;

    if (select.value !== preset) {
      select.value = preset;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function resetSelectToPlaceholderUnlessUrlPreset(root, select) {
    if (root.dataset.wdsUserChangedSelect === '1') return;
    if (getUrlTopicPreset() !== null) return;

    const selectControl = select.closest('.globo-form-control[data-type="select"]');
    if (selectControl) {
      selectControl.removeAttribute('data-default-value');
    }

    if (select.value === '') return;

    select.value = '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function resolveContactTarget() {
    const explicit = document.getElementById('contact');
    if (explicit) return explicit;

    const globoRoot = document.querySelector('.wds-contact-form [id^="globo-formbuilder-"]');
    if (globoRoot) {
      globoRoot.id = 'contact';
      return globoRoot;
    }

    const fallback = document.querySelector('[id^="globo-formbuilder-"]');
    if (fallback) {
      fallback.id = 'contact';
      return fallback;
    }

    return null;
  }

  function syncHashScroll() {
    const hash = window.location.hash || '';
    if (hashScrollHandled || !hash.startsWith(CONTACT_HASH)) return;

    const target = resolveContactTarget();
    if (!target) return;

    target.scrollIntoView({ behavior: 'auto', block: 'start' });
    hashScrollAttempts += 1;

    const isNearTop = Math.abs(target.getBoundingClientRect().top) < 4;
    if (isNearTop || hashScrollAttempts >= MAX_HASH_SCROLL_ATTEMPTS) {
      hashScrollHandled = true;
      return;
    }

    setTimeout(scheduleScan, 120);
  }

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  function setFieldVisibility(el, show) {
    if (!el) return;
    el.hidden = !show;
    el.setAttribute('aria-hidden', show ? 'false' : 'true');
    el.querySelectorAll('input, textarea, select').forEach(function (field) {
      field.disabled = !show;
      if (!show && field.type === 'file') {
        field.value = '';
      }
    });
  }

  function setFieldsVisibility(root, selector, show) {
    root.querySelectorAll(selector).forEach(function (el) {
      setFieldVisibility(el, show);
    });
  }

  function sync(root) {
    const select = root.querySelector('select[name="' + SELECT_NAME + '"]');
    if (!select) return;

    tryApplyUrlTopicPreset(root, select);
    resetSelectToPlaceholderUnlessUrlPreset(root, select);

    const hasSelectedTopic = select.value !== '';
    setFieldsVisibility(root, '.globo-form-control[data-type="name"]', hasSelectedTopic);
    setFieldsVisibility(root, '.globo-form-control[data-type="email"]', hasSelectedTopic);
    setFieldsVisibility(root, '.globo-form-control[data-type="textarea"]', hasSelectedTopic);
    setFieldsVisibility(root, '.globo-form-control.submit-note', hasSelectedTopic);
    setFieldsVisibility(root, '.gfb__footer.wizard__footer', hasSelectedTopic);

    const orderEl = root.querySelector(ORDER_SELECTOR);
    setFieldVisibility(orderEl, SHOW_ORDER_VALUES.includes(select.value));

    const productUrlEl = root.querySelector(PRODUCT_URL_SELECTOR);
    setFieldVisibility(productUrlEl, select.value === 'product');

    const fileUploadEl = root.querySelector(FILE_UPLOAD_SELECTOR);
    setFieldVisibility(fileUploadEl, select.value === 'return');

    const legalNoticeEl = root.querySelector(LEGAL_NOTICE_SELECTOR);
    setFieldVisibility(legalNoticeEl, select.value === 'return');

    const storeContactEl = root.querySelector(STORE_CONTACT_SELECTOR);
    setFieldVisibility(storeContactEl, select.value === 'store');
  }

  function initRoot(root) {
    if (root.dataset.wdsContactFormInit === '1') return;

    const select = root.querySelector('select[name="' + SELECT_NAME + '"]');
    if (!select) return;

    root.dataset.wdsContactFormInit = '1';
    select.addEventListener('change', function (event) {
      if (event && event.isTrusted) {
        root.dataset.wdsUserChangedSelect = '1';
      }
      sync(root);
    });
    sync(root);
  }

  function scan() {
    findFormRoots().forEach(function (root) {
      if (root.dataset.wdsContactFormInit === '1') {
        sync(root);
      } else {
        initRoot(root);
      }
    });
    syncHashScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan);
  } else {
    scheduleScan();
  }

  if (typeof MutationObserver !== 'undefined' && document.body) {
    const mo = new MutationObserver(scheduleScan);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('hashchange', function () {
    hashScrollHandled = false;
    hashScrollAttempts = 0;
    urlTopicPresetCache = undefined;
    findFormRoots().forEach(function (root) {
      root.dataset.wdsUserChangedSelect = '0';
    });
    scheduleScan();
  });

  window.addEventListener('load', function () {
    if ((window.location.hash || '').startsWith(CONTACT_HASH)) {
      hashScrollHandled = false;
      hashScrollAttempts = 0;
      scheduleScan();
    }
  });
})();
